import { Component } from "@angular/core";
import { NavHeaderComponent } from "../../shared/components/nav-header/nav-header.component";
import { NgOptimizedImage } from "@angular/common";
import { HeaderService } from "../../shared/services/header.service";

@Component({
    selector: "app-about-policystreet",
    standalone: true,
    imports: [NavHeaderComponent, NgOptimizedImage],
    templateUrl: "./about-ps.component.html",
    styleUrl: "./about-ps.component.scss",
})
export class AboutPSComponent {
    constructor(private headerService: HeaderService) {}

    onBack(): void {
        this.headerService.sendExitWebViewMessage();
    }
}